// extracted by mini-css-extract-plugin
export default {"board":"Board_board__7zbCt","score":"Board_score__lYgdo","death":"Board_death__+alAn"};